import { createContext, useContext, ReactNode } from "react";
import { useSettings } from "../hooks/useSettings";

const SettingsContext = createContext<ReturnType<typeof useSettings> | null>(
  null,
);

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const settings = useSettings(false);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error(
      "useSettingsContext must be used within a SettingsProvider",
    );
  }
  return context;
};
